import { gql } from '@apollo/client'
import {
  ADDRESS_FRAGMENT,
  CONTACT_DETAIL_FRAGMENT,
  SOCIETY_FRAGMENT,
} from '../Fragments'

export const ESTIMATION_QUERY = gql`
  query estimation(
    $domiciliationId: Int!
    $paymentType: String!
    $legalStatusId: Int!
    $addressId: Int!
    $actionType: String!
    $mailServiceId: Int!
    $promoCodeId: Int
    $forwardingCountry: String
    $withLegalFormality: Boolean
  ) {
    estimation(
      domiciliationId: $domiciliationId
      paymentType: $paymentType
      legalStatusId: $legalStatusId
      addressId: $addressId
      actionType: $actionType
      mailServiceId: $mailServiceId
      promoCodeId: $promoCodeId
      forwardingCountry: $forwardingCountry
      withLegalFormality: $withLegalFormality
    ) {
      id
      paymentType
      promoCode {
        id
        percentage
        withdrawalInCents
        promoType
        durationInMonth
      }
      pricing {
        domiciliationNonReducedPrice
        domiciliationReducedPrice
        mailProductBasePrice
        commitmentReduction
        promoCodeReduction
        totalPrice
        totalPriceVat
        purchases {
          prettyName
          amount
        }
      }
    }
  }
`

export const QUOTATION_QUERY = gql`
  query quotations($domiciliationId: Int!) {
    lastQuotation(domiciliationId: $domiciliationId) {
      complementaryOptions
      legalFormality {
        id
      }
    }
  }
`

export const PROSPECT_SHOW_QUERY = gql`
  query getDomiciliation($id: Int!) {
    domiciliation(id: $id) {
      id
      paymentType
      address {
        ...AddressFragment
      }
      contactDetail {
        ...ContactDetailFragment
      }
      society {
        ...SocietyFragment
      }
      promoCode {
        id
      }
      securityToken
      products {
        title
      }
      forwardingAddress {
        country
      }
      mailService {
        id
      }
      countryConfig {
        id
      }
    }
  }
  ${ADDRESS_FRAGMENT}
  ${CONTACT_DETAIL_FRAGMENT}
  ${SOCIETY_FRAGMENT}
`

export const ESTIMATIONS_QUERY = gql`
  query estimations(
    $domiciliationId: Int!
    $legalStatusId: Int!
    $addressId: Int!
    $mailServiceId: Int!
    $actionType: String!
    $forwardingCountry: String
    $withLegalFormality: Boolean
  ) {
    estimations(
      domiciliationId: $domiciliationId
      legalStatusId: $legalStatusId
      addressId: $addressId
      mailServiceId: $mailServiceId
      actionType: $actionType
      forwardingCountry: $forwardingCountry
      withLegalFormality: $withLegalFormality
    ) {
      id
      paymentType
      promoCode {
        id
      }
      pricing {
        domiciliationNonReducedPrice
        domiciliationReducedPrice
        mailProductBasePrice
        commitmentReduction
        promoCodeReduction
        totalPrice
        totalPriceVat
        purchases {
          prettyName
          amount
        }
      }
    }
  }
`

export const CREATE_ESTIMATIONS_MUTATION = gql`
  mutation createEstimations(
    $domiciliationId: Int!
    $legalStatusId: Int!
    $addressId: Int!
    $mailServiceId: Int!
    $estimations: [EstimationArgument!]!
    $actionType: String!
    $forwardingCountry: String
    $withLegalFormality: Boolean
  ) {
    createEstimations(
      domiciliationId: $domiciliationId
      legalStatusId: $legalStatusId
      addressId: $addressId
      mailServiceId: $mailServiceId
      estimations: $estimations
      actionType: $actionType
      forwardingCountry: $forwardingCountry
      withLegalFormality: $withLegalFormality
    ) {
      estimations {
        id
        paymentType
        promoCode {
          id
        }
        pricing {
          domiciliationNonReducedPrice
          domiciliationReducedPrice
          mailProductBasePrice
          commitmentReduction
          promoCodeReduction
          totalPrice
          totalPriceVat
          purchases {
            prettyName
            amount
          }
        }
      }
    }
  }
`

export const SEND_ESTIMATIONS_MUTATION = gql`
  mutation sendEstimations(
    $domiciliationId: Int!
    $estimationIds: [Int!]!
    $complementaryOptionIds: [Int!]
    $toAdmin: Boolean!
    $hubspotDropboxEmail: String
    $language: Languages!
  ) {
    sendEstimations(
      domiciliationId: $domiciliationId
      estimationIds: $estimationIds
      complementaryOptionIds: $complementaryOptionIds
      toAdmin: $toAdmin
      hubspotDropboxEmail: $hubspotDropboxEmail
      language: $language
    ) {
      success
    }
  }
`
